module.exports = __webpack_public_path__ + "static/media/meter.70219daa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/GetAShareResources/meter.svg
// module id = 175
// module chunks = 0